import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  /** Solid fill/stroke colour. When omitted, the Cydea brand gradient is used. */
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

// famicons:alert-outline (exclamation) — gradient-filled by default (the "unavailable" gate),
// or solid `color` (e.g. white) for the amber warning disc. Figma node 16194:11205. Ticket 7127.
export const AlertOutlineSvg: React.FC<Props> = ({ color, style, className }) => {
  const { colors } = useTheme();
  const id = `alert_${Math.random().toString(36).slice(2)}`;
  const paint = color ?? `url(#${id})`;

  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M18 4.5C17.1896 4.5 16.4485 5.006 16.5028 5.6L17.2514 20.45C17.2514 20.5959 17.3303 20.7358 17.4707 20.8389C17.6111 20.9421 17.8015 21 18 21C18.1985 21 18.3889 20.9421 18.5293 20.8389C18.6697 20.7358 18.7486 20.5959 18.7486 20.45L19.4972 5.6C19.5515 5.006 18.8104 4.5 18 4.5Z"
        fill={paint}
        stroke={paint}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 31.5C19.6569 31.5 21 30.1569 21 28.5C21 26.8431 19.6569 25.5 18 25.5C16.3431 25.5 15 26.8431 15 28.5C15 30.1569 16.3431 31.5 18 31.5Z"
        fill={paint}
      />
      {!color && (
        <defs>
          <linearGradient id={id} x1="15" y1="4.5" x2="21.5" y2="5.2" gradientUnits="userSpaceOnUse">
            <stop offset="0.0001" stopColor={colors.gp1} />
            <stop offset="1" stopColor={colors.gp2} />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};
